import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MerchantFormService } from 'src/app/service/APIs/merchant-form.service';

declare const grecaptcha: any;

@Component({
  selector: 'app-new-support',
  templateUrl: './new-support.component.html',
  styleUrls: ['./new-support.component.scss'],
})
export class NewSupportComponent implements OnInit {
  showModal = false;

  supportForm: FormGroup;
  isSubmitting = false;
  submitAlert: { type: 'success' | 'error'; message: string } | null = null;

  constructor(private fb: FormBuilder, private merchantFormService: MerchantFormService) {
    this.supportForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      issue: ['', Validators.required],
      message: ['', Validators.required],
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    if (this.supportForm.invalid) {
      this.supportForm.markAllAsTouched();
      return;
    }

    const captchaToken = typeof grecaptcha !== 'undefined' ? grecaptcha.getResponse() : '';

    if (!captchaToken) {
      this.submitAlert = { type: 'error', message: 'Please complete the reCAPTCHA verification.' };
      return;
    }

    this.isSubmitting = true;
    this.submitAlert = null;

    const { firstName, lastName, email, issue, message } = this.supportForm.value;

    this.merchantFormService.submitSupportRequest({ firstName, lastName, email, issue, message, captchaToken }).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.submitAlert = { type: 'success', message: 'Your message has been sent! We will get back to you shortly.' };
        this.supportForm.reset();
        if (typeof grecaptcha !== 'undefined') { grecaptcha.reset(); }
      },
      error: (err: any) => {
        this.isSubmitting = false;
        this.submitAlert = {
          type: 'error',
          message: err?.error?.message ?? 'Failed to send message. Please try again.',
        };
        if (typeof grecaptcha !== 'undefined') { grecaptcha.reset(); }
      },
    });
  }
}
